export const TRANSLATION_OPTIONS = 'CONFIG_OPTIONS';
